import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import AmountPageHeader from '../components/AmountPageHeader';
import AmountPageUserInput from '../components/AmountPageUserInput';
import AmountPageAccountDetails from '../components/AmountPageAccountDetails';
import SendMoneyWizardFooter from '../components/SendMoneyWizardFooter';
import { trackMixPanel } from '../../../services/mixpanel.service';
import { SendMoneyContext } from './SendMoney';

interface ITransferAmountPageProps {
  onSubmit: (amount: string) => void;
  subtitle: string;
}

const STYLES = {
  WRAPPER: 'w-full h-full flex justify-center items-center flex-col pt-[122px] bg-bw00',
  MAIN: 'w-[650px] grow flex flex-col items-center relative',
};

const TransferAmountPage = ({ onSubmit, subtitle }: ITransferAmountPageProps) => {
  const { balance } = useContext(SendMoneyContext);
  const [amount, setAmount] = useState<string>('');
  const [isFormValid, setIsFormValid] = useState<boolean>(false);
  const { t } = useTranslation();
  useEffect(() => {
    trackMixPanel('View Move Money Amount Screen', { Flow: 'plaid transfer out' });
  }, []);
  const handleContinueClick = () => {
    trackMixPanel('Act on Move Money Amount Screen', { Flow: 'plaid transfer out', Action: 'Continue' });
    if (isFormValid) onSubmit(amount);
  };

  return (
    <div className={STYLES.WRAPPER}>
      <div className={STYLES.MAIN}>
        <AmountPageHeader subtitle={subtitle} />
        <AmountPageUserInput setAmount={setAmount} setIsFormValid={setIsFormValid} />
        <AmountPageAccountDetails balance={balance} />
      </div>
      <SendMoneyWizardFooter
        className='w-[375px]'
        isLoading={false}
        onClick={handleContinueClick}
        disabled={!isFormValid}
        title={t('SEND_MONEY.WIZARD_FOOTER_BUTTONS.AMOUNT_STEP')}
      />
    </div>
  );
};

export default TransferAmountPage;
